import { useMutation } from '@tanstack/react-query';
import { ApiResponse, ShoppingItemData } from '../types/api';
import WebApp from '@twa-dev/sdk';


const API_URL = 'https://red.sigma-dev.co.ua/mini/shop/create';

async function fetchData(name: string): Promise<ApiResponse> {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'init-data': WebApp.initData,
    },
    body: JSON.stringify({
      name,
    }),

  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
}

export function useApiShopCreateItem() {
  return useMutation<ApiResponse, Error, string>({
    mutationFn: fetchData,
    mutationKey: ['shopCreateItem'],
  });
} 